import * as React from 'react';
import Icon from '../icon';
import Menu, { MenuBaseProps } from '../menu';
import Typography from '../typography';

import {
	Button,
	ButtonContent,
	IconLayout,
	Sign,
	Separator,
	ItemIconLayout,
} from './styled';


export type ActionButtonProps = {
	label: React.ReactNode;
} & Pick<MenuBaseProps, 'PopperProps'>

const ActionButtonBase: React.SFC<ActionButtonProps> = (props) => {
	const {
		label,
		PopperProps,
		children,
	} = props;

	return (
		<Menu.Base trigger={
			<Button>
				<ButtonContent>
					<Sign>
						<Typography.Text color='#fff' textTransform='uppercase' fontWeight={500} fontSize={13}>
							{label}
						</Typography.Text>
					</Sign>
					<IconLayout>
						<Separator>|</Separator>
						<Icon type='arrow-drop-down' color='white' />
					</IconLayout>
				</ButtonContent>
			</Button>
			}
			PopperProps={PopperProps}>
			{children}
		</Menu.Base>
	);
}

ActionButtonBase.displayName = 'ActionButtonBase';
ActionButtonBase.defaultProps = {
	PopperProps: {},
};

const ActionButton = {
	Base: ActionButtonBase,
	ItemIconLayout,
};

export default ActionButton;
